import React, {useEffect} from "react";
 
import AuthForm from '../../../components/Auth/AuthForm';
import OrContainer from "../../../components/Auth/OrContainer";
import SocialMediaContainer from "../../../components/Auth/SocialMediaContainer";
import { useSelector, useDispatch } from "react-redux";
import { createSession } from "../../../store/entities/Auth/Auth.actions";
import { useHistory } from "react-router-dom";
import URLS from "../../../config/navigation";
import {selectIsLoggedIn} from "../../../store/selectors/Auth";
import HelmetComponent from "../../../components/Common/Helmet";
import TitleComponent from "../../../components/Auth/TitleContainer";
const SignIn = () => {
   
  const isLoggedIn = useSelector(selectIsLoggedIn);
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    if (isLoggedIn) history.push(URLS.PROFILE.DATA);
  }, [isLoggedIn]);

  const handleSubmitSignIn = (values, { setSubmitting }) => {
    dispatch(createSession({ ...values }));
  };

  return (
    <div className={"container"}>
       <HelmetComponent title="Log in - TeachOn"/>
      
      <TitleComponent title={"Log in to your account"} />
     
      <div className={"formContainer"}>
        {/*<SocialMediaContainer />*/}
        {/*<OrContainer />*/}
        <AuthForm handleSubmit={handleSubmitSignIn} submitText={'Log In'}>
          <div className={"auth-links"}>
            <a className={"linkTag BODY_MEDIUM"} onClick={() => history.push(URLS.AUTH.FORGOT_PASSWORD)}>Forgot your password?</a>
          </div>
        </AuthForm>
        <span className={"haveAcc BODY_MEDIUM"}>Don’t have an account? <a className={'techOnlink BODY_MEDIUM'} onClick={() => history.push(URLS.AUTH.SIGNUP)}>Sign up for free!</a>
        </span>
      </div>
    </div>
  );
}

export default SignIn;
